import React, { useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Popover,
  Checkbox,
  OutlinedInput,
  Box,
  Button,
  Divider,
} from "@material-ui/core";
import { Check, Search } from "@material-ui/icons";
import { staticValueFinder } from "../../HelperFunctions";
const ColumnsFilterIndividual = ({ column, open, onClose, anchor }) => {
  const columnFilterValue = column.getFilterValue();
  console.log("running columns filter");
  const sortedUniqueValues = React.useMemo(() => {
    const rowData = column.getFacetedRowModel()?.rows;

    const renderValues = rowData.map((row) => {
      const cellObj = {
        getValue: () => {
          return row.original[column.id];
        },
        getContext: () => {
          return null;
        },
      };
      const value = staticValueFinder(column.columnDef.componentType, cellObj);
      console.log(value, "value new");
      return typeof value === "string" && value
        ? value.split(",").map((el) => el.trim())
        : "";
    });

    const uniqueValues = Array.from(
      new Set(renderValues.flatMap((el) => el)).keys()
    ).sort();
    return uniqueValues;
  }, [column.getFacetedRowModel()]);

  useEffect(() => {
    setDisplayList(sortedUniqueValues);
    if (!columnFilterValue) {
      setChecked(sortedUniqueValues);
    }
  }, [sortedUniqueValues]);
  // Popup open controls

  let initialValues = sortedUniqueValues;

  if (columnFilterValue && columnFilterValue?.length > 0) {
    initialValues = columnFilterValue;
  }

  const [checked, setChecked] = useState(initialValues);
  const [displayList, setDisplayList] = useState(sortedUniqueValues);
  const [searchText, setSearchText] = useState("");

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value;
    setSearchText(searchTerm);
    setDisplayList((prev) => {
      if (searchTerm === "") {
        return [...sortedUniqueValues];
      }
      if (searchTerm.toL !== "") {
        return sortedUniqueValues.filter((el) =>
          el?.toLowerCase().match(searchTerm.toLowerCase())
        );
      }
    });
  };
  const handleSubmit = () => {
    if (checked.length === sortedUniqueValues.length) {
      column.setFilterValue(undefined);
    } else {
      column.setFilterValue([...checked]);
    }
    onClose();
  };

  return (
    <Popover
      marginThreshold={32}
      anchorEl={anchor}
      id={"filter-selector-popover"}
      open={open}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      style={{
        height: "400px",
        maxHeight: "400px",
      }}
      PaperProps={{
        style: {
          width: "270px",
          height: "400px",
          padding: "0.5rem",
          maxHeight: "400px",
        },
      }}
      onClose={onClose}
    >
      <Box
        display={"flex"}
        height={"100%"}
        flexDirection={"column"}
        alignItems={"space-between"}
        gridRowGap={"0.5rem"}
      >
        <Box display={"flex"} justifyContent={"flex-end"}>
          <Button
            color="primary"
            style={{ textTransform: "none" }}
            onClick={() => {
              setChecked([...sortedUniqueValues]);
            }}
          >
            Select all
          </Button>
          <Button
            color="primary"
            style={{ textTransform: "none" }}
            onClick={() => {
              setChecked([]);
            }}
          >
            Clear
          </Button>
        </Box>
        <Box width={"90%"} flexGrow={1} margin={"0 auto"}>
          <OutlinedInput
            id="search_inside_column"
            value={searchText}
            onChange={handleSearch}
            endAdornment={<Search />}
            fullWidth
          />

          <List
            style={{
              overflowY: "scroll",
              maxHeight: "240px",
            }}
          >
            {displayList.length > 0 ? (
              displayList.map((value) => {
                const labelId = `checkbox-list-label-${value}`;
                return (
                  <ListItem
                    key={value}
                    button
                    onClick={handleToggle(value)}
                    dense
                  >
                    <ListItemIcon style={{ minWidth: 0 }}>
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        checkedIcon={<Check htmlColor="#232323" />}
                        icon={
                          <div style={{ width: "24px", height: "24px" }}></div>
                        }
                        inputProps={{ "aria-labelledby": labelId }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      id={labelId}
                      primary={value ? value : "(Blanks)"}
                    />
                  </ListItem>
                );
              })
            ) : (
              <ListItem>
                <ListItemText
                  style={{
                    textAlign: "center",
                    color: "#999",
                    fontSize: "8px",
                  }}
                >
                  No items found
                </ListItemText>
              </ListItem>
            )}
          </List>
          <Divider />
        </Box>

        <Box display={"flex"} justifyContent={"flex-end"}>
          <Button
            variant="outlined"
            style={{
              textTransform: "none",
              height: "2rem",
              marginRight: "0.5rem",
              width: "5rem",
            }}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            disableElevation
            variant="contained"
            style={{ textTransform: "none", height: "2rem", width: "5rem" }}
            color="primary"
            onClick={handleSubmit}
          >
            Ok
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default ColumnsFilterIndividual;
